import gql from "graphql-tag";

export const insightsRevenueQuery = gql`
  query insightsRevenue(
    $facilityId: ID!
    $startDate: String
    $endDate: String
    $comparisonStartDate: String
    $comparisonEndDate: String
    $asOf: String
  ) {
    insightsRevenue(
      facilityId: $facilityId
      startDate: $startDate
      endDate: $endDate
      comparisonStartDate: $comparisonStartDate
      comparisonEndDate: $comparisonEndDate
      asOf: $asOf
    ) {
      currentPeriod {
        startDate
        endDate
        metrics {
          grossParkingRevenue
          hotelNetRevenue
          refunds
          drivoFees
          bookingCount
        }
        daily {
          date
          hotelNetRevenue
          refunds
        }
      }
      previousPeriod {
        startDate
        endDate
        metrics {
          grossParkingRevenue
          hotelNetRevenue
          refunds
          drivoFees
          bookingCount
        }
        daily {
          date
          hotelNetRevenue
          refunds
        }
      }
    }
  }
`;

export const insightsRevenueLeakageQuery = gql`
  query insightsRevenueLeakage(
    $facilityId: ID!
    $startDate: String
    $endDate: String
    $asOf: String
    $comparisonAsOf: Boolean
  ) {
    insightsRevenueLeakage(
      facilityId: $facilityId
      startDate: $startDate
      endDate: $endDate
      asOf: $asOf
      comparisonAsOf: $comparisonAsOf
    ) {
      startDate
      endDate
      dayCount
      items { type amount count averagePerDay }
    }
  }
`;

export const insightsRevenueSegmentsQuery = gql`
  query insightsRevenueSegments(
    $facilityId: ID!
    $startDate: String
    $endDate: String
    $asOf: String
  ) {
    insightsRevenueSegments(
      facilityId: $facilityId
      startDate: $startDate
      endDate: $endDate
      asOf: $asOf
    ) {
      startDate
      endDate
      items { rateCardId name revenue }
    }
  }
`;

export const insightsOccupancyQuery = gql`
  query insightsOccupancy(
    $facilityId: ID!
    $startDate: String
    $endDate: String
    $comparisonStartDate: String
    $comparisonEndDate: String
    $asOf: String
  ) {
    insightsOccupancy(
      facilityId: $facilityId
      startDate: $startDate
      endDate: $endDate
      comparisonStartDate: $comparisonStartDate
      comparisonEndDate: $comparisonEndDate
      asOf: $asOf
    ) {
      startDate
      endDate
      previousStartDate
      previousEndDate
      granularity
      parkingOccupancyPercent
      previousParkingOccupancyPercent
      hotelOccupancyPercent
      previousHotelOccupancyPercent
      drivoChargeRatePercent
      previousDrivoChargeRatePercent
      points {
        timestamp
        label
        parkingOccupancyPercent
        hotelOccupancyPercent
        previousParkingOccupancyPercent
        previousHotelOccupancyPercent
      }
    }
  }
`;

export const getFeatureFacilityProviderConfigurationsQuery = gql`
  query getFeatureFacilityProviderConfigurations(
    $featureId: ID
    $providerId: ID
    $facilityId: ID
  ) {
    getFeatureFacilityProviderConfigurations(
      featureId: $featureId
      providerId: $providerId
      facilityId: $facilityId
    ) {
      id
      configuration
      feature {
        id
        name
      }
      provider {
        id
        name
      }
      facility {
        id
      }
    }
  }
`;

export const createFeatureFacilityProviderConfigurationMutation = gql`
  mutation createFeatureFacilityProviderConfiguration(
    $featureId: ID!
    $providerId: ID!
    $facilityId: ID!
    $configuration: JSON
  ) {
    createFeatureFacilityProviderConfiguration(
      featureId: $featureId
      providerId: $providerId
      facilityId: $facilityId
      configuration: $configuration
    ) {
      id
      configuration
    }
  }
`;

export const updateFeatureFacilityProviderConfigurationMutation = gql`
  mutation updateFeatureFacilityProviderConfiguration(
    $id: ID!
    $configuration: JSON
  ) {
    updateFeatureFacilityProviderConfiguration(
      id: $id
      configuration: $configuration
    ) {
      id
      configuration
    }
  }
`;

export const updateInsightsConfigurationMutation = gql`
  mutation updateInsightsConfiguration(
    $facilityId: ID!
    $patch: JSON!
  ) {
    updateInsightsConfiguration(
      facilityId: $facilityId
      patch: $patch
    ) {
      id
      configuration
    }
  }
`;

export const insightsNightAuditQuery = gql`
  query insightsNightAudit(
    $facilityId: ID!
    $date: String!
  ) {
    insightsNightAudit(
      facilityId: $facilityId
      date: $date
    ) {
      id
      date
      roomsSold
      averageDailyRate
      fnbRevenuePerRoom
      otherRevenuePerRoom
      hotelOccupancyPercent
      pmsParkingRevenue
      pmsParkingChargeCount
      drivoParkingRevenue
      drivoParkingChargeCount
      status
      postedAt
      postedByUser {
        id
        name
      }
    }
  }
`;

export const insightsNightAuditsQuery = gql`
  query insightsNightAudits(
    $facilityId: ID!
    $month: String
    $fromDate: String
    $toDate: String
  ) {
    insightsNightAudits(
      facilityId: $facilityId
      month: $month
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      date
      roomsSold
      averageDailyRate
      fnbRevenuePerRoom
      otherRevenuePerRoom
      hotelOccupancyPercent
      pmsParkingRevenue
      pmsParkingChargeCount
      drivoParkingRevenue
      drivoParkingChargeCount
      status
      postedAt
      postedByUser {
        id
        name
      }
    }
  }
`;

export const updateInsightsNightAuditMutation = gql`
  mutation updateInsightsNightAudit(
    $id: ID!
    $input: UpdateInsightsNightAuditInput!
  ) {
    updateInsightsNightAudit(
      id: $id
      input: $input
    ) {
      id
      date
      roomsSold
      averageDailyRate
      fnbRevenuePerRoom
      otherRevenuePerRoom
      hotelOccupancyPercent
      pmsParkingRevenue
      pmsParkingChargeCount
      drivoParkingRevenue
      drivoParkingChargeCount
      status
      postedAt
      postedByUser {
        id
        name
      }
    }
  }
`;

export const insightsSanctionedPlateStatisticsQuery = gql`
  query insightsSanctionedPlateStatistics(
    $facilityId: ID!
    $date: String!
  ) {
    insightsSanctionedPlateStatistics(
      facilityId: $facilityId
      date: $date
    ) {
      date
      sanctionedPlateHours
    }
  }
`;

export const getChargesByDateQuery = gql`
  query GetChargesByDate($input: QueryChargeByDateInput!) {
    getChargesByDate(input: $input) {
      questCharges {
        charges {
          id
          amount
          approved
        }
      }
      stripeCharges {
        stripeChargeId
        amountAud
        approved
      }
    }
  }
`;

export const insightsMonthlyRevparSummariesQuery = gql`
  query insightsMonthlyRevparSummaries(
    $facilityId: ID!
    $fromMonth: String
    $toMonth: String
  ) {
    insightsMonthlyRevparSummaries(
      facilityId: $facilityId
      fromMonth: $fromMonth
      toMonth: $toMonth
    ) {
      month
      label
      auditCount
      postedAuditCount
      roomsSold
      averageDailyRate
      fnbRevenuePerRoom
      otherRevenuePerRoom
      occupancyPercent
      revPAR
      drivoParkingRevPAR
      bookingParkingRevPAR
      totalRevPAR
      pmsParkingRevenue
      pmsParkingChargeCount
      parkingRevenue
      parkingHours
    }
  }
`;
